import { render, staticRenderFns } from "./NewCardDialog.vue?vue&type=template&id=6989ab87&scoped=true&"
import script from "./NewCardDialog.vue?vue&type=script&lang=js&"
export * from "./NewCardDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewCardDialog.vue?vue&type=style&index=0&id=6989ab87&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6989ab87",
  null
  
)

export default component.exports